import { INotificationsProvider } from "./abstractions"
import { CapacitorPushHandler } from "./providers/capacitor-push"

export const notificationsProvider: INotificationsProvider =
  new CapacitorPushHandler()
